import { render, staticRenderFns } from "./UvPrecautions.vue?vue&type=template&id=60f8c5cc&scoped=true"
import script from "./UvPrecautions.vue?vue&type=script&lang=js"
export * from "./UvPrecautions.vue?vue&type=script&lang=js"
import style0 from "./UvPrecautions.vue?vue&type=style&index=0&id=60f8c5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8c5cc",
  null
  
)

export default component.exports